import { LucideIcon } from "lucide-react";

interface CategoryCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  onClick: () => void;
}

const CategoryCard = ({ icon: Icon, title, description, onClick }: CategoryCardProps) => {
  return (
    <button
      onClick={onClick}
      className="group flex flex-col gap-2 rounded-lg border border-border bg-card p-4 text-left transition-all hover:glow-border hover:glow-cyan"
    >
      <div className="flex items-center gap-3">
        <div className="rounded-md bg-primary/10 p-2 transition-colors group-hover:bg-primary/20">
          <Icon className="h-4 w-4 text-primary" />
        </div>
        <h3 className="text-sm font-semibold">{title}</h3>
      </div>
      <p className="text-xs text-muted-foreground leading-relaxed">{description}</p>
    </button>
  );
};

export default CategoryCard;
